export default __webpack_public_path__ + "static/media/checkboxIcon.2caa6d84.svg";